import React from "react";

import Button from "@mui/joy/Button";
import IconButton from "@mui/joy/IconButton";


class CommonCallBackButton extends React.Component {
    render() {
        let argument;
        if (this.props[this.props.propsObject]){
            if (this.props[this.props.propsObject]){
                argument = this.props[this.props.propsObject][this.props.propsObjectKey]
            }
        }
        return(
            <>
                {
                    this.props.label?
                        <Button
                            onClick={() => (this.props.callBack(argument))}
                            startDecorator={this.props.icon?<this.props.icon fontSize={'small'}/>:null}
                            color={this.props.color?this.props.color:'neutral'}
                            size={'sm'}
                            sx={this.props.flat?{mt: 0, mb: 0, mr: 0}:{mt: 1, mb: 1, mr: 1}}
                            variant={this.props.variant?this.props.variant:'plain'}
                        >
                            {this.props.label?this.props.label:null}
                        </Button>:
                        <IconButton
                            size={'sm'}
                            onClick={() => (this.props.callBack(argument))}
                            sx={this.props.flat?{mt: 0, mb: 0, mr: 0}:{mt: 1, mb: 1, mr: 1}}
                            color={this.props.color?this.props.color:'neutral'}
                            variant={this.props.variant?this.props.variant:'plain'}
                        >
                            <this.props.icon fontSize={'small'}/>
                        </IconButton>
                }
            </>
        )
    }
}

export default CommonCallBackButton
